import React from "react";

import { IPropertyCharact } from "../../../../shared/interfaces/IProperties";

import { Topic } from "../styles";

import { parser } from "./helpers";

interface PropertyCharactProps {
    charact: IPropertyCharact;
}

export const PropertyCharact: React.FC<PropertyCharactProps> = ({
    charact,
}) => {
    return (
        <>
            {Object.keys(charact).map((group) => {
                const items = [...charact[group]]
                    .filter(
                        ({ pergunta, resposta }) =>
                            pergunta !== "INCENDIO" && resposta !== null
                    )
                    .sort((a, b) => {
                        const grupoA = Number(a.ordemgrupo || 0);
                        const grupoB = Number(b.ordemgrupo || 0);
                        if (grupoA !== grupoB) return grupoA - grupoB;
                        const ordemA = Number(a.ordempergunta || 0);
                        const ordemB = Number(b.ordempergunta || 0);
                        return ordemA - ordemB;
                    });

                return (
                    <div key={group} className="mb-8">
                        <Topic>
                            <h5>{group}</h5>
                        </Topic>

                        <div className="grid grid-cols-4 gap-x-4 gap-y-2">
                            {items.map(({ pergunta, resposta, id }) => (
                                <React.Fragment key={id}>
                                    <p>{pergunta}:</p>
                                    <p>{parser(pergunta, resposta)}</p>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                );
            })}
        </>
    );
};
